import { useMutation } from '@tanstack/react-query'

import { useShowingSignupResult } from '../context/showingSignupResult'

// Not apiFetch: the server returns per-field validation errors in the body of a
// non-ok response, and apiFetch throws those away.
const createShowingSignup = async (signup) => {
  const response = await fetch(
    `/api/user/projects/${signup.projectId}/showings/${signup.showingId}/signups`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(signup),
    }
  )

  const body = await response.json()

  if (!response.ok) {
    const error = new Error(body?.message || 'Showing signup failed')
    error.body = body
    throw error
  }

  return body
}

export const useCreateShowingSignup = () => {
  const { setResult } = useShowingSignupResult()

  return useMutation({
    mutationFn: createShowingSignup,
    onSuccess: (data) => setResult(data),
  })
}
